import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=dc0dac84&"
import script from "./Extension.vue?vue&type=script&lang=js&"
export * from "./Extension.vue?vue&type=script&lang=js&"
import style0 from "./Extension.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports